import gql from 'graphql-tag'

export default gql`
mutation ($slug: String!, $gender: String!, $limit: Int) {
  exportMostProgressDistance(slug: $slug, gender: $gender, limit: $limit) {
    downloadUrl
  }
}
`
